<template>
  <component :is="component"
    v-html="content"
    :data-text-prop="prop"
    :data-text-settings="JSON.stringify(options || {})"
  />
</template>

<script>
export default {
  props: {
    content: String,
    prop: String,
    component: {
      type: [String, Object],
      default: 'div',
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
